var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawerLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6114 25.872H15.7314V2.18396H20.8834C21.2754 2.18396 21.6114 2.51996 21.6114 2.91196V25.872Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1963 11.928L27.1003 13.832C27.2123 13.944 27.2123 14.168 27.1003 14.28L25.1963 16.128",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84417 11.1441V4.20006C1.84417 4.20006 1.78817 3.13606 2.96417 2.74406C3.07617 2.68806 11.5882 0.952059 13.3242 0.616059C13.5482 0.616059 13.7722 0.560059 13.8842 0.560059C14.2762 0.560059 15.1722 0.784059 15.2842 1.79206C15.2842 1.84806 15.2842 2.24006 15.2842 2.24006V25.9841C15.2842 25.9841 15.4522 27.3841 13.9402 27.3841C13.8282 27.3841 13.2682 27.2721 13.2682 27.2721L2.90817 25.2561C2.90817 25.2561 2.68417 25.2001 2.62817 25.2001C2.34817 25.0881 1.84417 24.8081 1.84417 23.8561V14.1121",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3965 26.0959H20.4365C21.2765 26.0399 21.6125 25.5359 21.7805 25.1999C21.8365 25.0879 21.8365 24.8639 21.8365 24.6959C21.8365 22.3999 21.8365 5.26393 21.8365 3.52793C21.8365 2.40793 21.1645 2.07193 20.8285 1.95993C20.7165 1.90393 20.4365 1.90393 20.4365 1.90393H19.4285",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5238 12.712H12.9878C13.0998 12.712 13.2118 12.824 13.2118 12.936V15.4C13.2118 15.512 13.0998 15.624 12.9878 15.624H10.5238C10.4118 15.624 10.2998 15.512 10.2998 15.4V12.88C10.2998 12.768 10.4118 12.712 10.5238 12.712Z",
    fill: "#EE2A7B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3723 14H18.0283",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerLogout);
export default __webpack_public_path__ + "static/media/drawer-logout.aadc0a06.svg";
export { ForwardRef as ReactComponent };